// ============================================================================
// IS THIS BUILDING LIVE — the one answer, on the screen side.
//
// ⛔ THE SCREEN DECIDES WHAT TO SHOW; THE DATABASE DECIDES WHAT TO ALLOW. This
// is the mirror of public.facility_is_live(), whose whole body is
// `facilities.status = 'Active'`, and it exists so the two cannot drift.
//
// Five things used to answer some version of this question, and one of the five
// was a private predicate inside save_service_line() that asked it of the LINE
// instead of the BUILDING. That predicate refused three buildings that had not
// opened — San Antonio, Davita Dallas Central and Orlando — while an account
// manager was doing nothing but setting them up. Ben, 2026-09-15: "Truth will
// never be prohibited by administration or gates or extra approvals."
//
// ⛔ These are DIFFERENT QUESTIONS and none of them belongs in here:
//   facilities.service_state              — have we paused or stopped service?
//   service_assignments.assignment_status — is THIS job running?
//   the active_facilities view            — its name means "not Closed".
// ============================================================================

/** The building has opened. Nothing else means that. */
export function facilityIsLive(status: string | null | undefined): boolean {
  return status === 'Active';
}

/**
 * Does a change to this line's money go through the rate-change process?
 *
 * Two questions, and conflating them was the defect. The BUILDING decides
 * whether money is moving at all; the LINE's own status decides whether this
 * particular job is one of the ones moving it. A line that ended, or was stood
 * down, or never started is not work Finance is waiting on, so correcting it
 * stays free even at a building that is open.
 *
 * ⛔ Keep this saying exactly what save_service_line() says.
 */
export function rateChangeApplies(
  facilityStatus: string | null | undefined,
  assignmentStatus: string | null | undefined,
): boolean {
  return (
    facilityIsLive(facilityStatus) &&
    (assignmentStatus === 'Active' || assignmentStatus === 'Scheduled')
  );
}

/** Running, or booked to run. What the money on a card counts before go-live. */
export function isRunningOrBooked(assignmentStatus: string | null | undefined): boolean {
  return assignmentStatus === 'Active' || assignmentStatus === 'Scheduled';
}
